function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Clean-design",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "01.01.-Brauk\\u0161anas-nodarb\\u012Bbas---Kopsavilkums",
  transform: "translate(-811.000000, -106.000000)",
  fill: "#E6812E"
}, /*#__PURE__*/React.createElement("g", {
  id: "Page-content",
  transform: "translate(270.000000, 30.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Blocks",
  transform: "translate(24.000000, 66.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Block-4",
  transform: "translate(507.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon-/-Checkmark",
  transform: "translate(10.000000, 10.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10,2 C14.418278,2 18,5.581722 18,10 C18,14.418278 14.418278,18 10,18 C5.581722,18 2,14.418278 2,10 C2,5.581722 5.581722,2 10,2 Z M10,6.2 C10.4418278,6.2 10.8,6.5581722 10.8,7 L10.8,11 C10.8,11.4418278 10.4418278,11.8 10,11.8 C9.5581722,11.8 9.2,11.4418278 9.2,11 L9.2,7 C9.2,6.5581722 9.5581722,6.2 10,6.2 Z M10,13.8 C10.4418278,13.8 10.8,13.4418278 10.8,13 C10.8,12.5581722 10.4418278,12.2 10,12.2 C9.5581722,12.2 9.2,12.5581722 9.2,13 C9.2,13.4418278 9.5581722,13.8 10,13.8 Z",
  id: "icon"
})))))));

function SvgIcWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "50CA890C-4489-470F-946D-43CBE0608580") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcWarning);
export default __webpack_public_path__ + "static/media/ic-warning.da59aa33.svg";
export { ForwardRef as ReactComponent };